<template>
  <div class="table-actions d-flex justify-content-start">
    <b-button
      v-if="view_show"
      :to="view_to_converted"
      :variant="view_variant"
      @click="$emit('show', item)"
      >{{ view_text }}</b-button
    >
    <b-button
      v-if="view_edit"
      :to="edit_to_converted"
      :variant="edit_variant"
      @click="$emit('edit', item)"
      ><font-awesome-icon :icon="edit_icon"
    /></b-button>
    <b-button
      @click="delete_item(item)"
      v-if="view_delete"
      variant="outline-danger"
    >
      <font-awesome-icon icon="trash-alt" />
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
    view_show: {
      default: true,
      type: Boolean,
    },
    view_edit: {
      default: true,
      type: Boolean,
    },
    view_delete: {
      default: true,
      type: Boolean,
    },
    view_text: {
      default: "Ver",
      type: String,
    },
    view_variant: {
      default: "info",
      type: String,
    },
    view_to: {
      type: String,
    },
    view_params: {
      type: Object,
      default: null,
    },

    edit_show: {
      default: true,
      type: Boolean,
    },
    edit_text: {
      default: "Editar",
      type: String,
    },
    edit_variant: {
      default: "outline-bagsis",
      type: String,
    },
    edit_to: {
      type: String,
    },
    edit_icon: {
      type: String,
      default: "edit",
    },

    edit_params: {
      type: Object,
      default: null,
    },

    delete_show: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    view_to_converted() {
      var params = this.view_params ? this.view_params : { id: this.item.id };

      return { name: this.view_to, params: params };
    },
    edit_to_converted() {
      var params = this.edit_params ? this.edit_params : this.item;
      return this.edit_to !== null
        ? { name: this.edit_to, params: params }
        : null;
    },
  },
  methods: {
    delete_item(item) {
      this.$bvModal
        .msgBoxConfirm("Você tem certeza que deseja excluir?", {
          okVariant: "danger",
          okTitle: "SIM",
          cancelVariant: "info",
          cancelTitle: "NÃO",
        })
        .then((value) => {
          if (value) {
            this.$emit("delete", item);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.table-actions {
  .btn {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0 !important;

    font-size: 1rem;
    padding: auto !important;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
